export default __webpack_public_path__ + "static/media/faq.c4089660.jpg";